import styled from "styled-components";
import { useState, useEffect } from "react";
import Back from "../../image/backButton.png";
import DeviceListModal from "./../Modal/DeviceListModal";
import { useTranslation } from "react-i18next";
import { FaCalendarAlt, FaCogs, FaRegListAlt } from "react-icons/fa"; // Importing icons from react-icons
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
import ko from "date-fns/locale/ko";
import el from "date-fns/locale/el";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import getMinutes from "date-fns/getMinutes";
import getHours from "date-fns/getHours";
import "./inputForm.css";
import DeviceMultiListModal from "../Modal/DeviceMultiListModal";

registerLocale("ja", ja);
registerLocale("ko", ko);
registerLocale("el", el);

export default function InputForm({
  startDate: start,
  endDate: end,
  selectedDevice: s,
  isMulti = false,
  deviceInputType, // 검색 방식
  setDeviceInputType, // 검색 방식 설정 함수
  manualDeviceInput, // 직접 입력한 기기명
  setManualDeviceInput, // 기기명 설정 함수
}) {
  const [deviceIsOpen, setDeviceIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endMaxDate, setEndMaxDate] = useState(null);
  const [endMinTime, setEndMinTime] = useState(null);
  const [endMaxTime, setEndMaxTime] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    if (isMulti) setSelectedDevice([]);
  }, [isMulti]);

  useEffect(() => {
    start(startDate);
  }, [startDate]);

  useEffect(() => {
    end(endDate);
  }, [endDate]);

  useEffect(() => {
    s(selectedDevice);
  }, [selectedDevice]);

  const openDevice = () => {
    setDeviceIsOpen(true);
  };

  const setStartDateFunc = (startDate) => {
    setStartDate(startDate);
    setEndDate(new Date(startDate.getTime() + 24 * 60 * 60 * 1000)); // default는 startDate + 24h
    setEndMaxDateFunc_change_start(startDate);
  };

  const setEndDateFunc = (startDate, endDate) => {
    setEndDate(endDate);
    setEndMaxDateFunc_change_end(startDate, endDate);
  };

  const { t, i18n } = useTranslation();

  const setEndMaxDateFunc_change_start = (startDate) => {
    if (!startDate) return null;
    if (getHours(startDate) > 0 || getMinutes(startDate) > 0) {
      setEndMaxDate(new Date(startDate.getTime() + 24 * 60 * 60 * 1000));
    } else if (getHours(startDate) === 0) {
      setEndMaxDate(startDate);
    }
    setEndMaxTimeFunc_change_start(startDate);
  };

  const setEndMaxTimeFunc_change_start = (startDate) => {
    if (!startDate) return null;
    setEndMaxTime(setHours(setMinutes(new Date(), 59), 23));
    setEndMinTime(
      setHours(
        setMinutes(new Date(), startDate?.getMinutes()),
        startDate?.getHours()
      )
    );
  };

  const setEndMaxDateFunc_change_end = (startDate, endDate) => {
    if (!startDate || !endDate) return null;
    if (getMinutes(startDate) > 0) {
      setEndMaxDate(new Date(startDate.getTime() + 24 * 60 * 60 * 1000));
    } else if (getHours(startDate) === 0) {
      setEndMaxDate(startDate);
    }
    setEndMaxTimeFunc_change_end(startDate, endDate);
  };

  const setEndMaxTimeFunc_change_end = (startDate, endDate) => {
    if (endDate) {
      if (endDate.getDay() === startDate.getDay()) {
        setEndMaxTime(setHours(setMinutes(new Date(), 59), 23));
        setEndMinTime(
          setHours(
            setMinutes(new Date(), startDate?.getMinutes()),
            startDate?.getHours()
          )
        );
      } else {
        setEndMaxTime(
          setHours(
            setMinutes(new Date(), startDate?.getMinutes()),
            startDate?.getHours()
          )
        );
        setEndMinTime(setHours(setMinutes(new Date(), 0), 0));
      }
    }
  };

  return (
    <InputContainer>
      <InputGroup style={{ width: "auto" }}>
        {/* Start Date */}
        <InputBox>
          <InputTitleCell>
            <FaCalendarAlt style={{ marginRight: "8px" }} />
            시작일
          </InputTitleCell>
          <DatePickerStyled
            showTimeSelect
            selected={startDate}
            onChange={(date) => setStartDateFunc(date)}
            timeIntervals={30}
            maxDate={new Date()}
            dateFormat="yyyy-MM-dd HH:mm"
          />
        </InputBox>

        {/* End Date */}
        <InputBox>
          <InputTitleCell>
            <FaCalendarAlt style={{ marginRight: "8px" }} />
            종료일
          </InputTitleCell>
          <DatePickerStyled
            showTimeSelect
            selected={endDate}
            onChange={(date) => setEndDateFunc(startDate, date)}
            timeIntervals={30}
            minDate={startDate}
            maxDate={new Date()}
            dateFormat="yyyy-MM-dd HH:mm"
          />
        </InputBox>
      </InputGroup>

      <InputGroup>
        {/* Option with Radio Buttons */}
        <InputBox>
          <InputTitleCell>
            <FaRegListAlt style={{ marginRight: "8px" }} />장치타입
          </InputTitleCell>
          <InputCell>
            <RadioGroup>
              <label style={{ textIndent: "10px" }}>
                <input
                  type="radio"
                  name="deviceInputType"
                  value="select"
                  checked={deviceInputType === "select"}
                  onChange={(e) => setDeviceInputType(e.target.value)}
                />
                등록 장치
              </label>
              <label style={{ textIndent: "10px" }}>
                <input
                  type="radio"
                  name="deviceInputType"
                  value="input"
                  checked={deviceInputType === "input"}
                  onChange={(e) => setDeviceInputType(e.target.value)}
                />
                미등록 장치
              </label>
            </RadioGroup>
          </InputCell>
        </InputBox>

      {/* Device Selection */}
      {startDate ? (
        deviceInputType === "select" ? (
          <InputBox
            onClick={endDate ? openDevice : null}
            style={{
              borderBottom: "none",
              cursor: endDate ? "pointer" : "auto",
              opacity: endDate ? 1 : 0.5,
              minWidth: "280px",
            }}
          >
            <InputTitleCell>
              <FaCogs style={{ marginRight: "8px" }} />
              장치검색
            </InputTitleCell>
            <InputCell>
              {selectedDevice && selectedDevice.length > 0
                ? selectedDevice.length > 1
                  ? `${selectedDevice[0]} 외 ${selectedDevice.length}개`
                  : selectedDevice[0]
                : "이 곳을 클릭하여 조회할 시리얼을 선택하세요."}
            </InputCell>
            <DropdownBtnContainer>
              <DropdownBtn />
            </DropdownBtnContainer>
          </InputBox>
        ) : (
          <InputBox style={{ borderBottom: "none", justifyItems: "left", borderRadius: "3px" }}>
            <InputTitleCell>
              <FaCogs style={{ marginRight: "8px" }} />
              장치검색
            </InputTitleCell>
            <InputCell>
              <input
                type="text"
                value={manualDeviceInput}
                onChange={(e) => {
                  setManualDeviceInput(e.target.value);
                  setSelectedDevice([e.target.value]);
                }}
                placeholder={"모니터링에서 사용했던 Name값을 입력해주세요."}
                style={{
                  width: "100%",
                  maxWidth: "475px",
                  height: "40px",
                  borderRadius: "5px",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  padding: "0 10px",
                }}
              />
            </InputCell>
          </InputBox>
        )
      ) : (
        <InputBox style={{ opacity: 0.5 }}>
          <InputTitleCell>
            <FaCogs style={{ marginRight: "8px" }} />
            장치검색
          </InputTitleCell>
        </InputBox>
      )}
    </InputGroup>

    {/* Device Selection Modal */}
    {isMulti ? (
      <DeviceMultiListModal
        isOpen={deviceIsOpen}
        isClose={setDeviceIsOpen}
        setSelectedDevice={setSelectedDevice}
      />
    ) : (
      <DeviceListModal
        isOpen={deviceIsOpen}
        isClose={setDeviceIsOpen}
        selectedDevice={setSelectedDevice}
      />
    )}
  </InputContainer>
  );
}

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  width: 100%;
`;

const InputBox = styled.div`
  display: grid;
  grid-template-columns: 25% 65% 10%;
  align-items: center;
  width: 100%;
  height: 50px;
  background-color: #f9f9f9;
  border: none; /* 테두리 제거 */
  padding: 0 15px;
  font-family: 'Noto Sans', sans-serif; /* 고급스러운 글꼴 사용 */
`;

const InputTitleCell = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem; /* 폰트 크기를 키움 */
  color: #555; /* 약간 진한 회색으로 변경 */
  white-space: pre;
`;

const InputCell = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  & input {
    width: 100%;
    font-size: 1.1rem; /* 폰트 크기를 키움 */
    font-family: 'Noto Sans', sans-serif; /* 고급스러운 글꼴 사용 */
    color: #333; /* 텍스트 색상 */
    background-color: transparent; /* 배경을 투명하게 */
    border: none; /* 테두리 제거 */
    border-bottom: 2px solid #ddd; /* 하단 테두리 */
    padding: 5px 10px; /* 여백 추가 */
    outline: none; /* 포커스 시 외곽선 제거 */
    transition: border-bottom-color 0.3s ease;

    &:focus {
      border-bottom-color: #0275d8; /* 포커스 시 하단 테두리 강조 */
    }

    &::placeholder {
      color: #aaa; /* 플레이스홀더 색상 */
      font-size: 1rem; /* 플레이스홀더 크기 */
    }
  }
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
  & label {
    display: flex;
    align-items: center;
    font-size: 1.1rem;
    color: #555;
    font-family: 'Noto Sans', sans-serif;
    cursor: pointer;
    position: relative;
    padding-left: 30px; /* 라디오 버튼과 텍스트 간격 조정 */
    margin-right: 20px;

    & input {
      position: absolute;
      left: 0;
      width: 20px;
      height: 22px;
      margin-right: 10px;
      border: 2px solid #0275d8; /* 버튼 테두리 색상 */
      border-radius: 50%;
      appearance: none; /* 기본 스타일 제거 */
      background-color: white;
      cursor: pointer;
      outline: none;
      transition: all 0.3s ease;

      &:checked {
        background-color: #0275d8; /* 선택 시 버튼 색상 */
        box-shadow: 0px 0px 0px 4px rgba(2, 117, 216, 0.2); /* 선택 시 강조 효과 */
      }

      &:before {
        content: '';
        display: block;
        width: 50%;
        height: 50%;
        border-radius: 50%;
        background-color: white;
        position: absolute
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s ease, background-color 0.3s ease;
      }

      &:checked:before {
        transform: scale(1);
        background-color: white; /* 선택 시 내부 색상 */
      }
    }
  }
`;


const DropdownBtn = styled.img.attrs({
  src: `${Back}`,
})`
  width: 20px;
  transform: rotate(270deg);
  filter: grayscale(100%); /* Subtle effect for dropdown */
  transition: filter 0.3s ease;
  &:hover {
    filter: grayscale(0%);
  }
`;

const DatePickerStyled = styled(DatePicker)`
  font-size: 1.1rem; /* 날짜 선택 인풋 박스의 폰트 크기 조정 */
  font-family: 'Noto Sans', sans-serif;
  color: #333; /* 텍스트 색상 */
  border: none; /* 테두리 제거 */
  padding: 5px 10px; /* 여백 추가 */
  background-color: transparent; /* 배경을 투명하게 */
  text-align: center;
  outline: none; /* 포커스 시 외곽선 제거 */
  &:focus {
    border-bottom: 2px solid #0275d8; /* 포커스 시 하단만 강조 */
  }
`;

const DropdownBtnContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: none;
  width: 100%;
`;